<template>
  <ul>
    <template v-for="(item, index) in items" :key="index">
      <li class="services-landing__third-level-desktop-item" :id="item.id" @click="setActive(item)">
        <span class="services-landing__third-level-desktop-item-inner" :class="{ 'services-landing__third-level-desktop-item-inner--active': active && active.id === item.id }">
          {{ item.title }}
        </span>
      </li>
    </template>
  </ul>
</template>

<script>
import { store } from "../../store.js";

export default {
  props: ["items"],
  components: {},
  data() {
    return {
      active: null,
    };
  },
  watch: {
    items: function () {
      this.$nextTick(() => {
        this.active = null;
        store.serviceOverview = null;
      });
    },
  },
  methods: {
    updateOverview: function (overview) {
      this.$emit("update-overview", overview);
    },
      setActive: function (item) {
        
      this.active = item;
      store.serviceOverview = item;
    },
  },
};
</script>
